import { __awaiter, __generator } from "tslib";
import { Component, EventEmitter, Input, Output, ViewEncapsulation, } from '@angular/core';
import * as _ from 'lodash';
import { EventViewMode, } from 'src/app/services/definitions.service';
import { ThreadSafeService } from 'src/app/services/thread-safe-component-state.service';
import * as i0 from "@angular/core";
import * as i1 from "src/app/services/common-functions.service";
import * as i2 from "@angular/material/dialog";
import * as i3 from "@angular/router";
import * as i4 from "@angular/common";
import * as i5 from "@angular/material/card";
import * as i6 from "@angular/material/divider";
import * as i7 from "../wp-view/wp-view.component";
function GroupedWorkPackagesComponent_mat_card_1_div_9_table_1_Template(rf, ctx) { if (rf & 1) {
    var _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table");
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "wp-view", 5);
    i0.ɵɵlistener("componentChanged", function GroupedWorkPackagesComponent_mat_card_1_div_9_table_1_Template_wp_view_componentChanged_4_listener($event) { i0.ɵɵrestoreView(_r7); var ctx_r6 = i0.ɵɵnextContext(3); return ctx_r6.wpChanged($event); })("componentLoaded", function GroupedWorkPackagesComponent_mat_card_1_div_9_table_1_Template_wp_view_componentLoaded_4_listener() { i0.ɵɵrestoreView(_r7); var wp_r5 = ctx.$implicit; var ctx_r8 = i0.ɵɵnextContext(3); return ctx_r8.wpViewLoaded(wp_r5); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var wp_r5 = ctx.$implicit;
    var ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("display", ctx_r4.showWp(wp_r5) || ctx_r4.isDebugMode() ? "" : "none");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.showWpDebugInfo(wp_r5), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", wp_r5)("users", ctx_r4.users)("accountingYear", ctx_r4.accountingYear)("userOptions", ctx_r4.userOptions)("event", ctx_r4.event)("viewMode", ctx_r4.viewMode);
} }
function GroupedWorkPackagesComponent_mat_card_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GroupedWorkPackagesComponent_mat_card_1_div_9_table_1_Template, 5, 9, "table", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var wps_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", wps_r3);
} }
function GroupedWorkPackagesComponent_mat_card_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-card", 2);
    i0.ɵɵelementStart(1, "mat-card-header");
    i0.ɵɵelementStart(2, "mat-card-subtitle");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-card-title");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "mat-divider");
    i0.ɵɵelementStart(8, "mat-card-content");
    i0.ɵɵtemplate(9, GroupedWorkPackagesComponent_mat_card_1_div_9_Template, 2, 1, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 3, ctx_r0.getDate(), "dd.MM.YYYY"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.dayName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.groupedWps);
} }
function GroupedWorkPackagesComponent_mat_card_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-card", 6);
    i0.ɵɵelementStart(1, "mat-card-header");
    i0.ɵɵelementStart(2, "mat-card-title");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-card-content", 7);
    i0.ɵɵtext(5, "Alle Schichten belegt oder beendet");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.getDayName(ctx_r1.viewData == null ? null : ctx_r1.viewData.date));
} }
var GroupedWorkPackagesComponent = /** @class */ (function () {
    function GroupedWorkPackagesComponent(common, dialog, route) {
        var _this = this;
        this.common = common;
        this.dialog = dialog;
        this.route = route;
        this.componentChanged = new EventEmitter();
        this.componentLoaded = new EventEmitter();
        this.doReload = new EventEmitter();
        this.enumViewMode = EventViewMode;
        this.groupedWps = [];
        this.showOverall = true;
        this.newDate = new Date();
        this.debugModeOn = false;
        this.dayName = "";
        // Assign the data to the data source for the table to render
        this.common.registerEventEmitterHandlerUserData(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.userData = data;
                return [2 /*return*/];
            });
        }); });
    }
    //Info: Das Init wird nur ein mal gecalled, aber die Methode update() wird mehrfach gecalled.
    //Das liegt daran, dass es fuer jedes Datum ein neues DateGroupedWorkPackages-Objekt gibt.
    //Das laesst sich nicht so richtig mit dem ThreadSafeService verbinden, da der component state immer ueberschrieben wird.
    //Liegt eher am schlechten Design der Komponente. Da aber 'fast' alle Daten der Komponente bereits vorher geladen wurden,
    //ist das ok so.
    GroupedWorkPackagesComponent.prototype.ngOnInit = function () {
        var _this = this;
        //enable debug mode if set in url param
        this.routeSub = this.route.queryParams.subscribe(function (params) {
            _this.debugModeOn = params['debug'] === 'true';
        });
    };
    GroupedWorkPackagesComponent.prototype.ngAfterContentInit = function () {
        if (this.data) {
            // this.update();
            this.viewData = this.data;
            //sort by type
            this.groupedWps = _.values(_.groupBy(this.viewData.workPackages, 'type'));
            this.decideIfAllShiftsFull(this.data.workPackages);
            // console.log('(GWP) Emit loaded for group: ' + this.data.date.toDateString());
            this.componentLoaded.emit(true);
        }
    };
    GroupedWorkPackagesComponent.prototype.ngAfterViewInit = function () {
    };
    //Decide if a shift shall be shown
    GroupedWorkPackagesComponent.prototype.showWp = function (wp) {
        //at this point in time, no work packages are loaded. Return true to allow loading and then decide if to hide
        if (wp && wp.participants == undefined) {
            return true;
        }
        return this.common.showWpView(wp, this.viewMode, this.userData);
    };
    //If all shifts decide to hide (for whatever reason), set this grouped work package as full
    GroupedWorkPackagesComponent.prototype.decideIfAllShiftsFull = function (wps) {
        var _this = this;
        //if all work packages decide to hide, hide the whole group
        var all = wps.every(function (wp) { return !_this.common.showWpView(wp, _this.viewMode, _this.userData); });
        if (all) {
            // if (this.debugModeOn)
            //   console.log(
            //     '(GWP) Group will not show'
            //   );
            this.showOverall = false;
        }
        else {
            // if (this.debugModeOn)
            //   console.log('(GWP) Group can be shown');
            this.showOverall = true;
        }
        return this.showOverall;
    };
    GroupedWorkPackagesComponent.prototype.getDayName = function (date) {
        this.dayName = this.common.getDayName(date);
    };
    GroupedWorkPackagesComponent.prototype.wpChanged = function () {
        var _a;
        // this.update();
        //propagate to upward component
        (_a = this.componentChanged) === null || _a === void 0 ? void 0 : _a.emit();
    };
    //To avoid: Expression has changed after it was checked
    GroupedWorkPackagesComponent.prototype.getDate = function () {
        if (this.viewData)
            return this.viewData.date;
        return new Date();
    };
    //Called when sub compoenent is loaded
    GroupedWorkPackagesComponent.prototype.wpViewLoaded = function (workPackage) {
        // console.log('(GWP): sub comp. wpView loaded: '+ workPackage.id);
    };
    //show debug info about a single work package
    GroupedWorkPackagesComponent.prototype.showWpDebugInfo = function (wp) {
        if (!this.debugModeOn) {
            return '';
        }
        return this.common.showWpDebugInfo(wp, this.userData, this.viewMode);
    };
    //Show debug info about the grouped work package
    GroupedWorkPackagesComponent.prototype.showGWpDebugInfo = function () {
        if (!this.debugModeOn) {
            return '';
        }
        return "Decision to show overall: " + this.showOverall;
    };
    GroupedWorkPackagesComponent.prototype.isDebugMode = function () {
        return this.debugModeOn;
    };
    GroupedWorkPackagesComponent.ɵfac = function GroupedWorkPackagesComponent_Factory(t) { return new (t || GroupedWorkPackagesComponent)(i0.ɵɵdirectiveInject(i1.CommonFunctionsService), i0.ɵɵdirectiveInject(i2.MatDialog), i0.ɵɵdirectiveInject(i3.ActivatedRoute)); };
    GroupedWorkPackagesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GroupedWorkPackagesComponent, selectors: [["grouped-work-packages"]], inputs: { data: "data", users: "users", accountingYear: "accountingYear", userOptions: "userOptions", event: "event", viewMode: "viewMode" }, outputs: { componentChanged: "componentChanged", componentLoaded: "componentLoaded", doReload: "doReload" }, features: [i0.ɵɵProvidersFeature([ThreadSafeService])], decls: 3, vars: 3, consts: [["style", "margin-top: 10px", 4, "ngIf"], ["style", "margin: 10px", 4, "ngIf"], [2, "margin-top", "10px"], [4, "ngFor", "ngForOf"], [3, "display", 4, "ngFor", "ngForOf"], [3, "data", "users", "accountingYear", "userOptions", "event", "viewMode", "componentChanged", "componentLoaded"], [2, "margin", "10px"], [2, "margin-left", "15px"]], template: function GroupedWorkPackagesComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtext(0);
            i0.ɵɵtemplate(1, GroupedWorkPackagesComponent_mat_card_1_Template, 10, 6, "mat-card", 0);
            i0.ɵɵtemplate(2, GroupedWorkPackagesComponent_mat_card_2_Template, 6, 1, "mat-card", 1);
        } if (rf & 2) {
            i0.ɵɵtextInterpolate1("", ctx.showGWpDebugInfo(), " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.showOverall);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.showOverall);
        } }, directives: [i4.NgIf, i5.MatCard, i5.MatCardHeader, i5.MatCardSubtitle, i5.MatCardTitle, i6.MatDivider, i5.MatCardContent, i4.NgForOf, i7.WpViewComponent], pipes: [i4.DatePipe], styles: [".card[_ngcontent-%COMP%] {\n    \n    margin: 20px;\n  }\n  \n  tr.spaceUnder[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n    padding-bottom: 1em;\n  }\n  \n  .tbl-icons[_ngcontent-%COMP%] {\n    width: 8%;\n  }\n  \n  .tbl-content[_ngcontent-%COMP%] {\n    width: 90%;\n  }\n  \n  .data-table[_ngcontent-%COMP%] {\n    margin-top: 10px;\n  }\n  \n  .footer-icon[_ngcontent-%COMP%] {\n    margin: 20px;\n    margin-top: 15px;\n    \n  }\n  \n  @media screen and (min-width: 700px) {\n    .data-table[_ngcontent-%COMP%] {\n      margin-left: 40px;\n      margin-top: 10px;\n    }\n    .tbl-content[_ngcontent-%COMP%] {\n      width: 95%;\n    }\n  }\n  \n  .flex-container[_ngcontent-%COMP%] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    position: absolute;\n    right: 0;\n  }\n  \n  .flex-container[_ngcontent-%COMP%]    > div[_ngcontent-%COMP%] {\n    margin: 5px;\n    text-align: left;\n    width: 40px;\n  }\n  \n  .flex-container[_ngcontent-%COMP%]    > div[_ngcontent-%COMP%]    > mat-icon[_ngcontent-%COMP%] {\n    cursor: pointer;\n  }\n  \n  .mat-card-footer[_ngcontent-%COMP%] {\n    text-align: right;\n  }\n  \n  table[_ngcontent-%COMP%] {\n    width: 100%;\n    margin-top: 20px;\n    max-width: 600px;\n    \n  }\n  \n  table[_ngcontent-%COMP%]    > tr[_ngcontent-%COMP%]    > td[_ngcontent-%COMP%] {\n    padding-bottom: 1em;\n  }\n  \n  .spacer-date[_ngcontent-%COMP%] {\n    margin-top: 10px;\n    margin-bottom: 5px;\n    font-size: 1.5em;\n  }\n/*# sourceMappingURL=data:application/json;base64,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 */"] });
    return GroupedWorkPackagesComponent;
}());
export { GroupedWorkPackagesComponent };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupedWorkPackagesComponent, [{
        type: Component,
        args: [{
                selector: 'grouped-work-packages',
                templateUrl: './grouped-work-packages.component.html',
                styleUrls: ['./grouped-work-packages.component.css'],
                encapsulation: ViewEncapsulation.Emulated,
                providers: [ThreadSafeService],
            }]
    }], function () { return [{ type: i1.CommonFunctionsService }, { type: i2.MatDialog }, { type: i3.ActivatedRoute }]; }, { data: [{
            type: Input
        }], users: [{
            type: Input
        }], accountingYear: [{
            type: Input
        }], userOptions: [{
            type: Input
        }], event: [{
            type: Input
        }], viewMode: [{
            type: Input
        }], componentChanged: [{
            type: Output
        }], componentLoaded: [{
            type: Output
        }], doReload: [{
            type: Output
        }] }); })();
//# sourceMappingURL=grouped-work-packages.component.js.map